'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../modules/jquery.history');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    (function (Filters, $) {

        var isSidebarAjaxClick = false;
        Shopify.queryParams = {};
        var initSidebar = function initSidebar() {
            perPageCollection();
            getCurrentTag();
            sidebarMapClear();
            sidebarMapClearAll();
            sidebarMapPaging();
            sidebarMapEvents();
        };
        var perPageCollection = function perPageCollection() {
            $('#select_results_per_page').on('change', function () {
                var pageValue = $(this).val();
                window.location.href = pageValue;
            });
        };

        var getCurrentTag = function getCurrentTag() {
            $(".tag_list").empty();
            $(".shop_filter .tag-filter ul").each(function (index, element) {
                $('li', this).each(function (index, element) {
                    $("input:checked", this).each(function (index, element) {
                        var current_tag_val = $(this).val();
                        var current_tag_name = $(this).next().text();
                        $(".tag_list").append("<span value='" + current_tag_val + "'>" + current_tag_name + " <i class='fa fa-times' ></i></span>");
                    });
                });
            });
            $(".tag_list").append(' <span class="clear-all"> Clear All </span>');
            $(".tag_list span , .apply_filter").click(function (e) {
                var currentTags = [];
                var remove_tag = $(this).attr("value");
                $(".shop_filter .tag-filter ul").each(function (index, element) {
                    $('li', this).each(function (index, element) {
                        $("input:checked", this).each(function (index, element) {
                            var current_tag_val = $(this).val();
                            if (current_tag_val == remove_tag) {} else {
                                currentTags.push($(this).val());
                            }
                        });
                    });
                });
                if (currentTags.length) {
                    $(".filter_tag").show();
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    $(".filter_tag").hide();
                    delete Shopify.queryParams.constraint;
                }

                if ($(this).hasClass('apply_filter')) {
                    $(".filter-icon.active").trigger('click');
                }

                sidebarAjaxClick();
                e.preventDefault();
            });
        };

        var sidebarMapEvents = function sidebarMapEvents() {
            sidebarMapTagEvents();
        };

        var sidebarAjaxClick = function sidebarAjaxClick(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = sidebarCreateUrl(baseLink);
            isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            sidebarGetContent(newurl);
        };

        var sidebarCreateUrl = function sidebarCreateUrl(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (newQuery != "") return location.pathname + "?" + newQuery;else return location.pathname + newQuery;
        };

        var showLoading = function showLoading() {
            $('.loading-modal').show();
        };

        var hideLoading = function hideLoading() {
            $('.loading-modal').hide();
        };

        var sidebarMapData = function sidebarMapData(data) {
            var currentList = $(".product_list > .collection-items-wrap");
            if (currentList.length == 0) {
                currentList = $(".product_list > .collection-items-wrap");
            }
            var productList = $(data).find(".product_list > .collection-items-wrap");

            if (productList.length == 0) {
                productList = $(data).find(".product_list > .collection-items-wrap");
            }
            currentList.replaceWith(productList);

            //replace paging 
            if ($(data).find(".pagination").length > 0) {
                $(".pagination").show();
                $(".pagination").replaceWith($(data).find(".pagination"));
            } else {
                $(".pagination").hide();
            }

            //replace tags            
            $(".shop_filter").replaceWith($(data).find(".shop_filter"));

            $('body').removeClass('body_blur');
            //open filter tab     
        };

        var sidebarMapClearAll = function sidebarMapClearAll() {
            //clear all selection
            $('.tag_list .clear-all,.back_clear .clear-all').click(function (e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                sidebarAjaxClick();
                $(".tag_list").empty();
                e.preventDefault();
            });
        };

        var sidebarMapClear = function sidebarMapClear() {
            $(".sidebar-tag").each(function () {
                var sidebarTag = $(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    $('.tag_list .clear-all').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display", "block").click(function (e) {
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function () {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        };

        var sidebarMapTagEvents = function sidebarMapTagEvents() {
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function (e) {
                var currentTags = [];
                var check_radio = $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if (check_radio == "radio") {
                    //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                sidebarAjaxClick();
                e.preventDefault();
            });
        };

        var sidebarGetContent = function sidebarGetContent(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function beforeSend() {
                    showLoading();
                },
                success: function success(data) {
                    sidebarMapData(data);
                    if ($(".shop_filter").length > 0) {
                        getCurrentTag();
                        sidebarMapClear();
                        sidebarMapClearAll();
                    }
                    sidebarMapPaging();
                    //phoenix.translateBlock("#collection_list");
                    sidebarMapTagEvents();
                    setTimeout(function () {
                        hideLoading();
                    }, 1000);
                },
                error: function error(xhr, text) {
                    hideLoading();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                }
            });
        };

        var sidebarMapPaging = function sidebarMapPaging() {
            $(".collection-filter .pagination a").click(function (e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = sidebarCreateUrl();
                        isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
        };

        Filters.init = function () {
            initSidebar();
            $(window).on('load', function () {});
            $(window).resize(function () {});
        };
    })(window.Filters = window.Filters || {}, _jquery2.default, undefined);
};